import React, { useState } from 'react'
import Button from '../../Components/Input/Button'
import PurchaseEpin from '../../Components/Epin/PurchaseEpin'
import EpinTable from '../../Components/Epin/EpinTable'

function Epin() {
    const [open, setOpen] = useState(false)
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
  return (
    <div>
    <PurchaseEpin
        open={open}
        handleClose={handleClose}
    />
        <h1 className=' text-2xl font-extrabold mb-3'>Buy airtime vouchers</h1>
        <Button
            name={'Buy E-pins'}
        onClick={handleOpen}
        />
        <div className=' my-4'>
            <EpinTable/>
        </div>
    </div>
  )
}

export default Epin